module.exports = __webpack_public_path__ + "img/sinecom.5e1cb2a7.png";